import { IScenarioFacilityCapacity } from '../../interfaces/iscenario-facility-capacity';
import { Asset } from '../asset';

export class ScenarioFacilityCapacityBase {
  ScenarioFacilityCapacityId: number;
  ScenarioId: number;
  AssetId: number;
  Date: Date;
  OilCapacity: number;
  GasCapacity: number;
  WaterCapacity: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Asset?: Asset;

  constructor(item?: IScenarioFacilityCapacity) {
    if (item) {

      this.ScenarioFacilityCapacityId = item.ScenarioFacilityCapacityId;
      this.ScenarioId = item.ScenarioId;
      this.AssetId = item.AssetId;
      this.Date = item.Date ? new Date(item.Date) : null;
      this.OilCapacity = item.OilCapacity;
      this.GasCapacity = item.GasCapacity;
      this.WaterCapacity = item.WaterCapacity;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Asset = new Asset(item.Asset);
    }
  }
}